export default {
    layoutSelector: 'Layout',
    TopBarLeft: 'Top Left',
    TopBarRight: 'Top Right',
    BottomBarLeft: 'Bottom Left',
    BottomBarRight: 'Bottom Right',
    SidebarRight: 'Right',
    SidebarLeft: 'Left',
    TopBar: 'Top',
    BottomBar: 'Bottom',
    createLocalPanel: 'Create local panel',
    createGlobalPanel: 'Create global panel',
    layoutPosition: 'Layout position',
    noLayoutPosition: 'None (free position)',
    noMarginBottom: 'No margin bottom',
    fontAutoSize: 'Auto size font based on screen resolution',
    invalidEmailFormat: 'Invalid email format',
    sendScreenshot: 'Send screenshot',
    selectedTemplate: 'Selected template',
    createNew: 'Create new template',
    selectExisting: 'Select existing template',
    templateName: 'Template name',
    setUserIdAsReplyTo: 'Use user login as reply-to address in email',
    LoginBlockEmailAdressHint: 'Make sure you enable in login block the option to allow only emails as input.',
    invalidEmailAddress: 'Invalid email address',
    OrSelectByStepName: 'Or select by step name',
    SelectByStepId: 'Select by step ID',
    partInfoHint: 'When clicking on a part in vSTAGE, the information from the fields selected below will be displayed.',
    navigation: 'Navigation',
    navigationSettingsInfo: 'Only projects the user has access to will be shown. For published projects the link will still point to private projects. Projects without a vform will not show up.',
    stepNavigation: 'Step Navigation',
    stepNavigationSettingsInfo: 'Renders a button for each step in this form, sorted by step order. The current step is highlighted using the active colors below.',
    buttonColor: 'Button text color',
    buttonBackgroundColor: 'Button background color',
    activeButtonColor: 'Active button text color',
    activeButtonBackgroundColor: 'Active button background color',
    noStepsFound: 'No steps found',
    step: 'Step',
    notApplicableInBar: 'n/a in bar',
    TextAlignment: 'Text alignment',
    backgroundColor: 'Background color',
    borderColor: 'Border color',
    fontColor: 'Font color',
    maximumLimitIs: 'The maximum is {limit}',
    minimumLimitIs: 'The minimum is {limit}',
    sort: 'Sort',
    filter: 'Filter',
    limit: 'Limit',
    noProjectsFound: 'No projects found',
    itemsFound: 'items found',
    currentProjectExcluded: 'The current project is excluded',
    savingFormFailed: 'Saving vForm failed. Possible cause can be invalid special characters in the text.',
    saveAnyway: 'Save anyway',
    formOutdatedAlert: 'There is a newer version of this form saved by {lastSavedBy} at {updatedAt}. If you proceed, those changes will be overwritten.',
    formSavingFailedAlert: 'Saving the form failed. Please try again.',
    projectOutdatedAlert: 'The project has been updated since last loaded by {lastSavedBy} at {updatedAt}. Do you want to reload the page to see the latest changes? Your unsaved changes will be lost.',
    formSavingFailedUnauthorizedAlert: 'Saving the form failed because you no longer have permission to edit this project.',
    abort: 'Abort',
    sourceLanguage: 'Source language',
    targetLanguage: 'Target language',
    language: 'Language',
    exportLanguage: 'Export language',
    importLanguage: 'Import language',
    uploadTranslationFile: 'Upload translation file',
    languageExportHint: 'Export as PO file for translation in a translation tool.',
    languageImportHint: 'Import the translated PO file to apply the translations into the vForm. The existing translations will be overwritten. The form will not be saved automatically, so you can check the result before saving.',
    languageImportCompleted: 'The language has been imported, possible existing translations have been overwritten. Please check the translations in the vForm and save only if the import was successful. Otherwise, reload the page.',
    progressTracker: 'Progress Tracker',
    restart: 'Restart',
    addAnotherFile: 'Add another file',
    originalText: 'Original text',
    translatedText: 'Translated text',
    manageLanguages: 'Manage languages',
    confirmDeleteLanguage: 'Are you sure you want to delete all translations for "{lang}"? This cannot be undone.',
    configureBottomBar: 'Configure bottom bar',
}